import { supabase } from "@/services/supabase/createClient";
import { useQuery, useQueryClient } from "@tanstack/react-query";

export const getPendingInvites = async (teamId: string) => {
  const { data, error } = await supabase.from("team_invites").select("*").eq("team_id", teamId).eq("status", "pending");

  if (error) {
    throw new Error(error.message);
  }

  return data;
};

export const usePendingInvites = (teamId?: string) => {
  return useQuery({
    queryKey: ["pending_invites", teamId || ""],
    queryFn: () => getPendingInvites(teamId || ""),
    enabled: !!teamId,
  });
};

export const usePendingInviteSubscription = () => {
  const queryClient = useQueryClient();
  return useQuery({
    queryKey: ["pending_invites_subscription"],
    queryFn: () => {
      const channels = supabase
        .channel("pending_invites_all")
        .on("postgres_changes", { event: "*", schema: "public", table: "team_invites" }, () => {
          queryClient.invalidateQueries({
            predicate: (query) => query.queryKey?.[0] === "pending_invites",
          });
        })
        .subscribe();
      return () => {
        channels.unsubscribe();
      };
    },
    refetchOnMount: false,
    refetchOnReconnect: false,
  });
};
